export default {
  getMode: state => {
    return state.mode;
  },

  /**
   * Returns the list of all the consoles
   * @param {*} state
   */
  getConsoles: state => {
    return state.consolesById.map(cId => state.consoles[cId]);
  },

  getStaticEntityMetaKeys: state => {
    if (state.staticEntities.length > 0) {
      return Object.keys(state.staticEntities[0].meta);
    } else return [];
  },

  getCurrentStaticEntity: state => {
    return state.staticEntityId;
  },

  getStaticEntities: state => {
    const filterIds = Object.keys(state.appliedFilters).reduce(
      (result, item) => {
        return Object.assign(result, {
          [item.split("__")[1]]: {
            id: item,
            name: item.split("__")[1],
            applied: state.appliedFilters[item],
          },
        });
      },
      {}
    );

    let filteredData = state.staticEntities.reduce((result, item) => {
      let keys = Object.keys(item.meta);
      let shouldFilter = false;
      keys.map(column => {
        if (
          filterIds[column] && // check if a filter is applied for the column
          filterIds[column].applied.length > 0 && // check if there are any filter
          !filterIds[column].applied.includes(item.meta[column]) // if the item doesn't fall under any of the applied filters
        ) {
          shouldFilter = true; // filter that item
        }
      });

      if (!shouldFilter) {
        result.push(item);
      }
      return result;
    }, []);
    return filteredData;
    // return state.staticEntities;
  },

  getStaticEntityFilters: state => {
    return state.staticEntityFilters[state.staticEntityId];
  },

  getAppliedFilters: state => {
    return state.appliedFilters;
  },

  getActiveLayer: state => {
    return state.activeLayer;
  },

  /**
   * Returns the isInitialized state of the console from the store
   */
  isInitialized: state => {
    return state.isInitialized;
  },

  /**
   * Returns the state of the request progress (widgets)
   */
  isRequestInProgress: state => {
    return state.isRequestInProgress;
  },

  /**
   * Returns the list of all layers present
   * Joins the data with active layers and indicates if the layer is active or not
   */
  getLayers: state => {
    // check if there are any layers in the store
    if (!(state.layersById && state.layersById.length > 0)) {
      return [];
    }
    // Check if the layer is present in the active layer list
    // return list of all the layers whilist indicating they're active or not
    return state.layersById.map(layerId => {
      // check if the layerId is present in activeLayers list
      if (state.activeLayer === layerId) {
        // if, yes set it as an active layer
        return Object.assign({}, state.layers[layerId], { isActive: true });
      } else {
        return state.layers[layerId];
      }
    });
  },

  getActiveLayerDetails: state => {
    if (state.activeLayer && state.layers) {
      return state.layers[state.activeLayer];
    }
  },

  getLayersById: state => {
    return state.layersById;
  },

  /**
   * Returns the list of all the activeLayers
   */
  // getActiveLayers: state => {
  //   // check if there are layers and activeLayers in the store.
  //   if (
  //     !(
  //       state.layersById &&
  //       state.layersById.length > 0 &&
  //       isEmpty(state.activeLayers)
  //     )
  //   ) {
  //     return [];
  //   }
  //   // return the layer metaData for all the activeLayers
  //   return Object.keys(state.activeLayers).map(layerId => {
  //     return state.layers[layerId];
  //   });
  // },

  getDetailsWidget: state => {
    if (state.staticEntityId && state.activeLayer && state.detailsWidgets) {
      return state.detailsWidgets[state.activeLayer];
    }
  },

  getDistributions: state => {
    if (
      state.staticEntityId &&
      state.activeLayer &&
      state.distributionWidgets
    ) {
      return state.distributionWidgets[state.activeLayer];
    }
  },

  /**
   * Returns the current active city for the console
   */
  getActiveCity: state => {
    return state.activeCity;
  },
};
